import { queryStringBuilder } from './queryStringBuilder';

export const fetchForDataGrid = async (request, query, dataTransform = (result) => result) => {
  if (!query || !request) return;

  const queryString = queryStringBuilder({
    page: query.pageNumber + 1,
    pageSize: query.pageSize,
    filters: query?.filters,
    orderBy: query.orderBy || null,
    direction: query.orderDirection || null,
    search: query.searchString,
  });

  return await request({ query: queryString })
    .then((result) => {
      return dataTransform({
        data: result.data,
        totalCount: result.itemCount,
        totalPages: result.pageCount,
      });
    })
    .catch((error) => {
      console.error(error);
      return {
        data: [],
        totalCount: 0,
      };
    });
};
